/* tslint:disable */
/* eslint-disable */
/* @relayHash efa33006a78b9b0ea40b2421f8c5c35c */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StudyPage_worksheetQueryVariables = {
    identifier: string;
};
export type StudyPage_worksheetQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "EmbedHeader_viewer" | "WorksheetStudier_viewer" | "WorksheetAuth_viewer">;
    } | null;
    readonly worksheetByIdentifier: {
        readonly isVisibleToViewer: boolean;
        readonly " $fragmentRefs": FragmentRefs<"WorksheetStudier_worksheet" | "WorksheetAuth_worksheet">;
    } | null;
};
export type StudyPage_worksheetQuery = {
    readonly response: StudyPage_worksheetQueryResponse;
    readonly variables: StudyPage_worksheetQueryVariables;
};



/*
query StudyPage_worksheetQuery(
  $identifier: String!
) {
  viewer {
    ...NavHeader_viewer
    ...EmbedHeader_viewer
    ...WorksheetStudier_viewer
    ...WorksheetAuth_viewer
  }
  worksheetByIdentifier(identifier: $identifier) {
    isVisibleToViewer
    ...WorksheetStudier_worksheet
    ...WorksheetAuth_worksheet
    id
  }
}

fragment EmbedHeader_viewer on Viewer {
  user {
    id
    username
    createdAt
  }
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment MultipleChoiceWidget_exercise on MultipleChoiceExercise {
  content {
    prompt
    choices {
      text
      isCorrect
    }
  }
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment TranslatorWidget_exercise on TranslationExercise {
  content {
    prompt
    correctAnswers
    scrambledParts
  }
}

fragment VocabWidget_exercise on VocabExercise {
  content {
    terms {
      word
      definition
      image {
        id
        url(size: LARGE_SQUARE)
      }
    }
  }
}

fragment WordOrderWidget_exercise on WordOrderExercise {
  content {
    correctAnswers
    scrambledParts
  }
}

fragment WorksheetAuth_viewer on Viewer {
  user {
    id
  }
}

fragment WorksheetAuth_worksheet on Worksheet {
  id
  title
  visibility
  isVisibleToViewer
}

fragment WorksheetStudier_viewer on Viewer {
  user {
    id
  }
}

fragment WorksheetStudier_worksheet on Worksheet {
  id
  title
  description
  identifier
  isPublished
  exercises {
    id
    __typename
    ... on TranslationExercise {
      ...TranslatorWidget_exercise
    }
    ... on WordOrderExercise {
      ...WordOrderWidget_exercise
    }
    ... on MultipleChoiceExercise {
      ...MultipleChoiceWidget_exercise
    }
    ... on VocabExercise {
      ...VocabWidget_exercise
      content {
        terms {
          word
          image {
            url(size: LARGE_SQUARE)
            id
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "identifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVisibleToViewer",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "prompt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "correctAnswers",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scrambledParts",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "StudyPage_worksheetQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "EmbedHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetStudier_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetAuth_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "WorksheetStudier_worksheet",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "WorksheetAuth_worksheet",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "StudyPage_worksheetQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "username",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAdmin",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isUpgradedTeacher",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "level",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v3/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "worksheetByIdentifier",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "Worksheet",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isPublished",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exercises",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "__typename",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "type": "TranslationExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TranslationExerciseContent",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "WordOrderExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WordOrderExerciseContent",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "MultipleChoiceExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "MultipleChoiceExerciseContent",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "choices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MultipleChoiceExerciseChoice",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "text",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCorrect",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "VocabExercise",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "content",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VocabExerciseContent",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "VocabExerciseTerm",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "word",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "definition",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "image",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Image",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "url",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "size",
                                    "value": "LARGE_SQUARE"
                                  }
                                ],
                                "storageKey": "url(size:\"LARGE_SQUARE\")"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "visibility",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "StudyPage_worksheetQuery",
    "id": null,
    "text": "query StudyPage_worksheetQuery(\n  $identifier: String!\n) {\n  viewer {\n    ...NavHeader_viewer\n    ...EmbedHeader_viewer\n    ...WorksheetStudier_viewer\n    ...WorksheetAuth_viewer\n  }\n  worksheetByIdentifier(identifier: $identifier) {\n    isVisibleToViewer\n    ...WorksheetStudier_worksheet\n    ...WorksheetAuth_worksheet\n    id\n  }\n}\n\nfragment EmbedHeader_viewer on Viewer {\n  user {\n    id\n    username\n    createdAt\n  }\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment MultipleChoiceWidget_exercise on MultipleChoiceExercise {\n  content {\n    prompt\n    choices {\n      text\n      isCorrect\n    }\n  }\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TranslatorWidget_exercise on TranslationExercise {\n  content {\n    prompt\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment VocabWidget_exercise on VocabExercise {\n  content {\n    terms {\n      word\n      definition\n      image {\n        id\n        url(size: LARGE_SQUARE)\n      }\n    }\n  }\n}\n\nfragment WordOrderWidget_exercise on WordOrderExercise {\n  content {\n    correctAnswers\n    scrambledParts\n  }\n}\n\nfragment WorksheetAuth_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment WorksheetAuth_worksheet on Worksheet {\n  id\n  title\n  visibility\n  isVisibleToViewer\n}\n\nfragment WorksheetStudier_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment WorksheetStudier_worksheet on Worksheet {\n  id\n  title\n  description\n  identifier\n  isPublished\n  exercises {\n    id\n    __typename\n    ... on TranslationExercise {\n      ...TranslatorWidget_exercise\n    }\n    ... on WordOrderExercise {\n      ...WordOrderWidget_exercise\n    }\n    ... on MultipleChoiceExercise {\n      ...MultipleChoiceWidget_exercise\n    }\n    ... on VocabExercise {\n      ...VocabWidget_exercise\n      content {\n        terms {\n          word\n          image {\n            url(size: LARGE_SQUARE)\n            id\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2427ed3062c7caa524ece9ad831f1ce2';
export default node;
